import '@angular/compiler';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app';
import { adoptManagerPreview } from './app/shared/services/jwt.service';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

adoptManagerPreview();

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err)); // Dodaj też obsługę błędu
